import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

export function setAdminToken(token) {
    if (token) {
        localStorage.setItem('leiha_admin_token', token);
    } else {
        localStorage.removeItem('leiha_admin_token');
    }
}

export function getAdminToken() {
    return localStorage.getItem('leiha_admin_token');
}

export function adminHeaders() {
    const token = getAdminToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatGBP(n) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(Number(n || 0));
}

export function formatDate(iso) {
    if (!iso) return '';
    try {
        const d = new Date(iso);
        return d.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
    } catch (_) {
        return iso;
    }
}
